import React from 'react';
import './css/Footer.css';
import discordIcon from './image/TweakBotLogo.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-logo">
            <img src={discordIcon} alt="TweakBot Logo" className="footer-logo-image" />
            <span className="footer-logo-text">TweakBot</span>
          </div>
          <p className="footer-description">
            Бот для развлечений, музыки и модерации вашего Discord сервера
          </p>
        </div>

        <div className="footer-section">
          <h3>Ссылки</h3>
          <ul className="footer-links">
            <li><a href="#commands">Команды</a></li>
            <li><a href="https://discord.gg/CaxKBEkMtp">Discord сервер</a></li>
            <li>
              <a href="https://discord.com/oauth2/authorize?client_id=1009421126776127548" className="invite-link">
                Добавить бота
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Соглашения</h3>
          <ul className="footer-links">
            <li><a href="https://docs.google.com/document/d/1N5KkccowWvckfUm8eFCu0wFkIYrflJf4RbAestwNW1U/edit?usp=sharing">Политика использования</a></li>
            <li><a href="https://docs.google.com/document/d/1Zl1mBlEbl38XvphIC6sMBesJQc3KHvreTMvyebd7dI8/edit?usp=sharing">Политика конфиденциальности</a></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2025 TweakBot. Все права защищены.</p>
      </div>
    </footer>
  );
};

export default Footer;